module.exports = __webpack_public_path__ + "img/africell_money.e882e747.png";